var render = function render(_c,_vm){return _c('div',{staticClass:"field is-horizontal"},[_c('div',{staticClass:"field-label is-normal"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.props.label))])]),_c('div',{staticClass:"field-body"},[_c('div',{class:`field flex items-center ${_vm.props.isNarrow ? 'is-narrow' : ''}`},[_c('div',{staticClass:"control w-full"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }